// @flow
// $FlowFixMe
import React, { useState } from 'react';

import { SUBSCRIPTION_TRIAL_DURATION_DAYS } from '../../constants';

import StripePaymentForm from './StripePaymentForm';
import PaymentSummary from './PaymentSummary';

import styles from './PaymentStep.css';
import stylesConversionForm from './ConversionFormVisual.css';
import { FormattedDate, FormattedMessage } from 'react-intl';

type OwnProps = {
  isInModal: boolean,
  selectedPlan: string | null,
  setSelectedPlan: Function,
  isTrialAvailable: boolean,
  trialDurationDays?: number,
  price: number,
  relativeDiscount?: number,
  reducedPriceDuration?: number,
  onSuccess?: Function,
  defaultPaymentType?: string,
  userIsAllowedOptOutTrial: boolean,
  goBack: Function,
  isStripeLoading: boolean,
  isValentine26Campaign: boolean,
};

type Props = OwnProps;

const PaymentStep = ({
  isInModal,
  selectedPlan,
  setSelectedPlan,
  isTrialAvailable,
  trialDurationDays = SUBSCRIPTION_TRIAL_DURATION_DAYS,
  price,
  relativeDiscount,
  reducedPriceDuration,
  onSuccess,
  defaultPaymentType,
  userIsAllowedOptOutTrial,
  goBack,
  isStripeLoading,
  isValentine26Campaign,
}: Props) => {
  const [activePaymentType, setActivePaymentType] = useState(defaultPaymentType);

  const HeaderText = () => {
    if (isValentine26Campaign) {
      return (
        <FormattedMessage
          id="premium.payment-step.title.valentine26"
          defaultMessage="A Gift from Cupid"
        />
      );
    }

    if (isTrialAvailable) {
      return (
        <FormattedMessage id="premium.payment-step.title.trial" defaultMessage="Start Your Trial" />
      );
    }
    return (
      <FormattedMessage id="premium.payment-step.title" defaultMessage="Complete Your Purchase" />
    );
  };

  return (
    <div className={stylesConversionForm.paymentGrid} data-test="conversion-form.payment-step-view">
      <PaymentSummary
        isTrialAvailable={isTrialAvailable}
        trialDurationDays={trialDurationDays}
        selectedPlan={selectedPlan}
        setSelectedPlan={setSelectedPlan}
        price={price}
        relativeDiscount={relativeDiscount}
        goBack={goBack}
        reducedPriceDuration={reducedPriceDuration}
        isStripeLoading={isStripeLoading}
      />
      <div className={styles.formContainer}>
        <h1 className={styles.title}>
          <HeaderText />
        </h1>
        <p className={styles.description}>
          {isTrialAvailable ? (
            <span data-test="payment-summary.trial" data-test-value={trialDurationDays}>
              <FormattedMessage
                id="premium.payment-step.trial.description"
                defaultMessage="You will not be charged today. We will send you a reminder 3 days before your first payment. Cancel anytime before {firstPaymentDate} to avoid being charged - no commitment."
                values={{
                  firstPaymentDate: (
                    <FormattedDate
                      value={new Date(Date.now() + (trialDurationDays + 1) * 24 * 60 * 60 * 1000)}
                    />
                  ),
                }}
              />
            </span>
          ) : (
            <FormattedMessage
              id="premium.payment-step.description"
              defaultMessage="Enter your payment details to start your journey. Your subscription will start today."
            />
          )}
        </p>
        <StripePaymentForm
          isInModal={isInModal}
          onSuccess={onSuccess}
          trialDurationDays={trialDurationDays}
          price={price}
          relativeDiscount={relativeDiscount}
          reducedPriceDuration={reducedPriceDuration}
          onPaymentTypeChange={setActivePaymentType}
          selectedPlan={selectedPlan}
          initialPaymentType={activePaymentType}
          userIsAllowedOptOutTrial={userIsAllowedOptOutTrial}
          isValentine26Campaign={isValentine26Campaign}
        />
      </div>
    </div>
  );
};

export default PaymentStep;
